import React from "react";
import { View, Text, TouchableOpacity, FlatList } from "react-native";

import { BoldText } from "components";

import { styles } from "./styles";

export const Picker = ({ options, textKey, onPress, selectedOption = {} }) => {
  return (
    <View style={[styles.modal, styles.listContainer]}>
      <FlatList
        data={options}
        contentContainerStyle={styles.list}
        keyExtractor={item => item.id.toString()}
        renderItem={({ item }) => {
          return (
            <TouchableOpacity
              style={
                selectedOption?.id === item.id
                  ? styles.selectedItem
                  : styles.item
              }
              onPress={() => onPress(item)}
            >
              <Text
                style={
                  selectedOption?.id === item.id
                    ? styles.selectedItemText
                    : styles.itemText
                }
              >
                <BoldText>{item[textKey]}</BoldText>
              </Text>
            </TouchableOpacity>
          );
        }}
      />
    </View>
  );
};
